import { useEffect, useState } from "react";
import { WalletLogTab } from "../../../../hooks/use-wallet-tab";
import { useWalletContext } from "../../../../hooks/wallet-context";
import { useWalletLogContext } from "../../../../hooks/wallet-log-context";
import { WalletSkeletonWhiteBox } from "../../../../style/skeleton";
import { WalletLogsHeaderValue, WalletLogsHeaderWrapper } from "./style";
import DropBox from "../../../../../../../components/drop-box";

const WalletLogsHeader = () => {
  const { logTab, isLogTab, pubList } = useWalletContext();
  const { point, loading, pub, setPub, getSubPrizeLogs, subPrizeLogs, year } =
    useWalletLogContext();
  const [isFilterOpen, setFilterIsOpen] = useState(false);
  const [isFirstLoading, setIsFirstLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      if (!loading) setIsFirstLoading(false);
    }, 150);
  }, [loading]);

  useEffect(() => {
    setIsFirstLoading(true);
  }, [pub]);

  const getHeaderText = () => {
    switch (logTab) {
      case WalletLogTab.POINT:
        return "매장이용권";
      case WalletLogTab.SEED:
        return "통합 크레딧";
      case WalletLogTab.MILEAGE:
        return "주류 마일리지";
      case WalletLogTab.SUBPRIZE:
        return "부상";
    }
  };

  const getPointUnit = () => {
    switch (logTab) {
      case WalletLogTab.POINT:
        return "E";
      case WalletLogTab.SEED:
        return "RABBIT";
      case WalletLogTab.MILEAGE:
        return "M";
      case WalletLogTab.SUBPRIZE:
        return "건";
    }
  };

  const getPoint = () => {
    if (!point) return 0;
    switch (logTab) {
      case WalletLogTab.POINT:
        return point / 10000;
      case WalletLogTab.SEED:
      case WalletLogTab.MILEAGE:
        return point;
      case WalletLogTab.SUBPRIZE:
        return point;
    }
  };

  useEffect(() => {
    if (logTab === WalletLogTab.SUBPRIZE) {
      getSubPrizeLogs();
    }
  }, [pub, year]);

  return (
    <WalletLogsHeaderWrapper>
      <WalletLogsHeaderValue>
        <div className="title">{getHeaderText()}</div>
        <div className="point">
          {loading && isFirstLoading ? (
            <WalletSkeletonWhiteBox width="150px" height="24px" />
          ) : (
            <>
              {getPoint()?.toLocaleString()}
              <span>{getPointUnit()}</span>
            </>
          )}
        </div>
      </WalletLogsHeaderValue>
      {!isLogTab(WalletLogTab.SEED) && (
        <DropBox
          value={pub}
          setValue={setPub}
          label={""}
          isOpen={isFilterOpen}
          setIsOpen={setFilterIsOpen}
          option={pubList}
        />
      )}
    </WalletLogsHeaderWrapper>
  );
};

export default WalletLogsHeader;
